// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__1d-gj","error":"Contacts_error__SCOhK"};